import * as React from "react";

function SvgCufflinks(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#cufflinks_svg__clip0)">
        <path d="M.919 10.437h8.34a.078.078 0 00.077-.078 4.247 4.247 0 10-8.495 0c0 .043.035.078.078.078zm1.248-1.539a3.01 3.01 0 012.778-1.841.505.505 0 110 1.009c-.808 0-1.534.48-1.848 1.225a.505.505 0 11-.93-.393zm7.17 2.282H.84a.841.841 0 100 1.682h3.406v2.652H2.95a.673.673 0 000 1.345h1.297v.689a.841.841 0 101.682 0v-.689h1.298a.673.673 0 000-1.345H5.93v-2.652h3.407a.841.841 0 100-1.682zm1.405-5.244h8.339a.078.078 0 00.078-.078 4.247 4.247 0 10-8.495 0c0 .044.035.078.078.078zm1.248-1.539a3.01 3.01 0 012.778-1.841.505.505 0 110 1.01c-.809 0-1.534.48-1.849 1.224a.505.505 0 11-.93-.393zm7.169 2.282h-8.495a.841.841 0 000 1.682h3.406v2.652h-1.297a.673.673 0 000 1.346h1.297v.688a.841.841 0 001.682 0v-.688h1.298a.673.673 0 000-1.346h-1.298V8.361h3.407a.841.841 0 000-1.682z" />
      </g>
    </svg>
  );
}

export default SvgCufflinks;
